import React, { useEffect } from 'react';

const INDECX_KEY = '5e46926028a0ef00ed5fc759';
const INDECX_ACTION = '618960d1e0696c1a9ed94b6f';

if (!window.__INDECX_WIDGET_LOADED__) {
  window.__INDECX_WIDGET_LOADED__ = false;
}

const useTrackWidget = (shouldLoad, isMobile) => {
  const scriptId = 'indecx-widget-js';
  const widgetContainerId = 'indecx-widget-container';
  const widgetMinimizedId = 'indecx-widget-minimized';

  useEffect(() => {
    const adjustWidgetPosition = () => {
      const widget = document.getElementById(widgetContainerId);
      const widgetMinimized = document.getElementById(widgetMinimizedId);
      if (!widget && !widgetMinimized) return;

      const right = isMobile ? '100px' : '150px';

      if (widget) {
        widget.style.setProperty('right', right);
      }

      if (widgetMinimized) {
        widgetMinimized.style.setProperty('right', right, 'important');
      }
    };

    const cleanup = () => {
      window.__INDECX_WIDGET_LOADED__ = false;

      const scriptEl = document.getElementById(scriptId);
      if (scriptEl) scriptEl.remove();

      const widgetContainer = document.getElementById(widgetContainerId);
      if (widgetContainer) widgetContainer.remove();

      const widgetMinimized = document.getElementById(widgetMinimizedId);
      if (widgetMinimized) widgetMinimized.remove();
    };

    const loadWidget = () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) existingScript.remove();

      cleanup();

      // Buscar dados do localStorage com fallbacks
      const nome = localStorage.getItem('storeName') || '';
      const email = localStorage.getItem('userEmail') || '';
      const telefone =
        localStorage.getItem('cellPhoneNumber') ||
        localStorage.getItem('userPhone') ||
        '';
      const cpfCnpj = localStorage.getItem('storeDocument') || 'CPF_INFO';
      const codeStore = localStorage.getItem('codeStore');
      const codCliente =
        (codeStore && codeStore.split('-')?.[0]) || 'COD_CLIENTE';
      const codEndereco =
        localStorage.getItem('storeId') ||
        localStorage.getItem('codeStore') ||
        'COD_ENDERECO';
      const estado = localStorage.getItem('userUf') || 'ESTADO';
      const cidade = localStorage.getItem('userCity') || 'CIDADE';

      const config = {
        key: INDECX_KEY,
        action: INDECX_ACTION,
        name: nome,
        email: email,
        phone: telefone,
        indicators: {
          cpf_cnpj: cpfCnpj,
          codCliente: codCliente,
          codEndereco: codEndereco,
          estado: estado,
          cidade: cidade,
        },
      };

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://indecx-widget.s3.amazonaws.com/widget-production-v3.js';
      script.type = 'text/javascript';
      script.async = true;

      script.onload = () => {
        if (window.__INDECX_WIDGET_LOADED__) return;

        try {
          const { IndeCX } = window;
          if (!IndeCX) {
            return;
          }

          IndeCX(config);
          window.__INDECX_WIDGET_LOADED__ = true;

          setTimeout(() => {
            adjustWidgetPosition();
          }, 500);
        } catch (error) {
          console.error('Erro ao inicializar IndeCX widget:', error);
        }
      };

      document.body.appendChild(script);
    };

    if (!shouldLoad) {
      cleanup();
      return;
    }

    if (window.__INDECX_WIDGET_LOADED__) {
      adjustWidgetPosition();
      return;
    }

    loadWidget();

    return cleanup;
  }, [shouldLoad, isMobile]);

  return null;
};

export default useTrackWidget;
